<template>
  <div class="row pl-3 pb-3 pr-3 pt-1 mr">
    <div class="col-md col-6 pt-3">
      <div class="regular text-gray">
        Fecha de firma:
      </div>
      <div class="regular" v-text="item.signDate || makeDummieDate()" />
    </div>

    <div class="col-md col-6 pt-3">
      <div class="regular text-gray">
        Usuario:
      </div>
      <div class="regular" v-text="item.userName || '-'" />
    </div>

    <div class="col-md col-6 pt-3">
      <div class="regular text-gray">
        Nombre:
      </div>
      <div class="regular" v-text="item.name || '-'" />
    </div>

    <div class="col-md col-6 pt-3">
      <div class="regular text-gray">
        Estatus:
      </div>
      <div class="regular" v-text="item.status || '-'" />
    </div>

    <div class="col-md col-6 pt-3">
      <div class="regular text-gray">
        Teléfono:
      </div>
      <div class="regular" v-text="getPhoneMasked || '-'" />
    </div>

    <slot name="actions" />
  </div>
</template>

<script>
import moment from 'moment';
import { masker, tokens } from 'ke-the-mask';

export default {
  name: 'RequesterItem',
  props: {
    item: { type: Object, default: null },
    submitted: { type: Boolean, default: false },
    useRole: { type: Boolean, default: false },
    roleLabel: { type: String, default: 'Rol' },
  },
  methods: {
    async sign(validate) {
      if (this.submitted) {
        return;
      }
      validate();
    },
    makeDummieDate() {
      return `${moment().format('DD/MMM/YYYY')}`.toLowerCase();
    },
  },
  computed: {
    getPhoneMasked() {
      if (!this.item.phone) return this.item.phone;
      return masker(this.item.phone, '(###)###-####', true, tokens);
    },
  },
};
</script>

<style lang="scss" scoped>
.sign-btn {
  border: 1px solid;
  font-size: 1rem;
  font-weight: 400;

  border: 1px solid #2db782;
  i {
    border: 1px solid #2db782;
  }

  &:hover {
    background-color: #2db782;
    transition: 0.2s ease;
    color: white;
  }
}
</style>
